import script from "./TransactionProofGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionProofGuide.vue?vue&type=script&setup=true&lang=js"

import "./TransactionProofGuide.vue?vue&type=style&index=0&id=3a0e5bd2&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0e5bd2"]])

export default __exports__